<div fxLayout="column">
    <div *ngIf="!hasBidQuotes" fxLayout="column" fxLayoutAlign="center center">
        <img alt="Illustration of a spreadsheet, a pen, and a calculator" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/accounts-spreadsheet-spot-hero.svg">

        <div class="forge-typography--heading2">No bids or quotes yet.</div>
    </div>

    <ng-container *ngFor="let bidQuote of bidQuotes">
        <bid-quote *ngIf="!bidQuote.IsDeleted" [canEdit]="canEdit" [model]="bidQuote" (onDelete)="onDelete($event)" (viewAttachments)="showAttachments($event)" (viewNotes)="showNotes($event)">
        </bid-quote>
    </ng-container>
</div>